import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

export const StyledSummaryHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.s}px;
`;

export const StyledSummaryMain = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  flex-wrap: wrap;
`;

export const StyledTitle = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-weight: 600;
`;

export const StyledActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs}px;
  flex-shrink: 0;
`;

export const StyledMeta = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
`;

export const StyledSearch = styled.input`
  width: 100%;
  height: 36px;
  padding: 0 ${({ theme }) => theme.spacing.sm}px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.m}px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 240px;
  overflow-y: auto;
  margin-top: ${({ theme }) => theme.spacing.s}px;
`;

export const StyledRow = styled.button.withConfig({ shouldForwardProp })<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.s}px;
  background-color: ${({ theme, $active }) => ($active ? theme.colors.surfaceHover : 'transparent')};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
  text-align: left;
  cursor: pointer;

  /* On the lit fill, meta text steps up to stay readable. */
  ${StyledMeta} {
    color: ${({ theme, $active }) =>
      $active ? theme.colors.textSecondary : theme.colors.textMuted};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
  }

  &:hover ${StyledMeta} {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const StyledRowMain = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.s}px;
  flex: 1;
  min-width: 0;
`;

export const StyledFooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.s}px;
`;

export const StyledCreate = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
  font-weight: 600;
  cursor: pointer;
`;

export const StyledNotice = styled.div.withConfig({ shouldForwardProp })<{
  $tone: 'warn' | 'danger';
}>`
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  color: ${({ theme, $tone }) =>
    $tone === 'danger' ? theme.colors.danger : theme.colors.textSecondary};
`;
